// extracted by mini-css-extract-plugin
module.exports = {"icon":"Page_icon__A9FS8","link":"Page_link__3qT_V"};